/**
 * Template para email de contacto principal
 * Enviado a info@amalgamatech.com con CC al usuario
 */
export const contactEmailTemplate = (data) => ({
  html: `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Nuevo mensaje de contacto</title>
      <style>
        body { 
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; 
          margin: 0; 
          padding: 0; 
          background-color: #f8fafc; 
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background: white; 
        }
        .header { 
          background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%); 
          padding: 40px 20px; 
          text-align: center; 
        }
        .header h1 { 
          color: white; 
          margin: 0; 
          font-size: 28px; 
          font-weight: 700; 
        }
        .content { 
          padding: 40px 20px; 
        }
        .field { 
          margin-bottom: 24px; 
        }
        .label { 
          font-weight: 600; 
          color: #374151; 
          margin-bottom: 8px; 
          display: block; 
        }
        .value { 
          background: #f9fafb; 
          padding: 16px; 
          border-radius: 8px; 
          border-left: 4px solid #0ea5e9; 
        }
        .footer { 
          background: #1f2937; 
          color: #9ca3af; 
          padding: 20px; 
          text-align: center; 
          font-size: 14px; 
        }
        @media (max-width: 600px) { 
          .container { margin: 0; } 
          .header, .content { padding: 20px 16px; } 
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Amalgamatech</h1>
          <p style="color: rgba(255,255,255,0.9); margin: 8px 0 0 0;">Nuevo mensaje de contacto</p>
        </div>
        <div class="content">
          <div class="field">
            <span class="label">Nombre:</span>
            <div class="value">${data.nombre}</div>
          </div>
          <div class="field">
            <span class="label">Email:</span>
            <div class="value">${data.email}</div>
          </div>
          <div class="field">
            <span class="label">Motivo:</span>
            <div class="value">${data.motivo}</div>
          </div>
          <div class="field">
            <span class="label">Mensaje:</span>
            <div class="value">${data.mensaje}</div>
          </div>
        </div>
        <div class="footer">
          <p>Este mensaje fue enviado desde el formulario de contacto de Amalgamatech</p>
        </div>
      </div>
    </body>
    </html>
  `,
  
  text: `Nombre: ${data.nombre}\nEmail: ${data.email}\nMotivo: ${data.motivo}\nMensaje: ${data.mensaje}`,
  
  subject: `${data.motivo} - Amalgamatech`
});